export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAIL = 'USERS_FAIL';

export function profileRequest() {
    return {
        type: USERS_REQUEST,
        payload: {},
    };
}
export const PROFILE_EMPLOYEE_REQUEST = 'PROFILE_EMPLOYEE_REQUEST';
export const PROFILE_EMPLOYEE_SUCCESS = 'PROFILE_EMPLOYEE_SUCCESS';
export const PROFILE_EMPLOYEE_FAIL = 'PROFILE_EMPLOYEE_FAIL';

export function profileEmployeeRequest() {
    return {
        type: PROFILE_EMPLOYEE_REQUEST,
        payload: {},
    };
}
export const URS_REQUEST = 'URS_REQUEST';
export const URS_SUCCESS = 'URS_SUCCESS';
export const URS_FAIL = 'URS_FAIL';

export function profileUrsRequest() {
    return {
        type: URS_REQUEST,
        payload: {},
    };
}
export const USER_CRM_REQUEST = 'USER_CRM_REQUEST';
export const USER_CRM_SUCCESS = 'USER_CRM_SUCCESS';
export const USER_CRM_FAIL = 'USER_CRM_FAIL';

export function userCrmRequest() {
    return {
        type: USER_CRM_REQUEST,
        payload: {},
    };
}

export const USER_IN_BLOCK_REQUEST = 'USER_IN_BLOCK_REQUEST';
export const USER_IN_BLOCK_SUCCESS = 'USER_IN_BLOCK_SUCCESS';
export const USER_IN_BLOCK_FAIL = 'USER_IN_BLOCK_FAIL';

export function userInBlockRequest() {
    return {
        type: USER_IN_BLOCK_REQUEST,
        payload: {},
    };
}
export const OGG_REQUEST = 'OGG_REQUEST';
export const OGG_SUCCESS = 'OGG_SUCCESS';
export const OGG_FAIL = 'OGG_FAIL';

export function oggRequest() {
    return {
        type: OGG_REQUEST,
        payload: {},
    };
}

export const MONEY_REQUEST = 'MONEY_REQUEST';
export const MONEY_SUCCESS = 'MONEY_SUCCESS';
export const MONEY_FAIL = 'MONEY_FAIL';

export function moneyRequest() {
    return {
        type: MONEY_REQUEST,
        payload: {},
    };
}
export const PRICE_REQUEST = 'PRICE_REQUEST';
export const PRICE_SUCCESS = 'PRICE_SUCCESS';
export const PRICE_FAIL = 'PRICE_FAIL';

export function priceRequest() {
    return {
        type: PRICE_REQUEST,
        payload: {},
    };
}

export function profileRequestLocal(data) {
    return {
        type: USERS_SUCCESS,
        payload: {data},
    };
}
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export function loginRequest({phone,password}) {
    return {
        type: LOGIN_REQUEST,
        payload: {phone,password},
    };
}

export const USERS_ADD_LOCAL = 'USERS_ADD_LOCAL';

export function callForwardLocal(data) {
    return {
        type: USERS_ADD_LOCAL,
        payload: { data },
    };
}
export const USERS_DELETE_LOCAL = 'USERS_DELETE_LOCAL';

export function callForwardDeleteLocal(id) {
    return {
        type: USERS_DELETE_LOCAL,
        payload: { id },
    };
}


export const EMPLOYEE_ISWEB_SET = 'EMPLOYEE_ISWEB_SET';
export function employeeIswebSet(isweb) {
    return {
        type: EMPLOYEE_ISWEB_SET,
        payload: { isweb },
    };
}

export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';
export function logoutAdmin() {
    return {
        type: LOGOUT_ADMIN,
        payload: {},
    };
}

export const UNREAD_CHANNELS_SET = 'UNREAD_CHANNELS_SET';
export function unreadChannelsSet({ whatsappEnabled, telegramEnabled, telegramMainId }) {
    return {
        type: UNREAD_CHANNELS_SET,
        payload: {
            whatsappEnabled: !!whatsappEnabled,
            telegramEnabled: !!telegramEnabled,
            telegramMainId: telegramMainId != null ? Number(telegramMainId) : null,
        },
    };
}

export const UNREAD_COUNTS_SET = 'UNREAD_COUNTS_SET';
export function unreadCountsSet({ whatsappUnread, telegramUnread }) {
    return {
        type: UNREAD_COUNTS_SET,
        payload: {
            whatsappUnread: Number(whatsappUnread || 0),
            telegramUnread: Number(telegramUnread || 0),
        },
    };
}